import {
  CampoSemanticoProcedimento,
  GetFrontRichiesteIdImmaginiIdDimensioni,
} from '@framework/api-client';
import { CampoSemantico } from '@framework/api-client/src/api/backoffice/schemas';
import { Space } from 'antd';
import { PreviewSubmissionImageAttachment } from '../PreviewSubmissionImageAttachment';

export interface IPreviewSemanticTagGroupRenderProps {
  images: CampoSemanticoProcedimento[] | CampoSemantico[];
  submissionId: string;
  objectFit?: 'cover' | 'contain' | 'fill' | 'none' | 'scale-down';
  width?: number;
  height?: number;
  borderRadius?: number;
  dimension?: GetFrontRichiesteIdImmaginiIdDimensioni;
}
export function PreviewSemanticTagGroupRender(
  props: IPreviewSemanticTagGroupRenderProps,
) {
  const {
    images,
    submissionId,
    objectFit,
    width,
    height,
    borderRadius,
    dimension,
  } = props;

  const previewImages = images.map(image => (
    <PreviewSubmissionImageAttachment
      submissionId={submissionId!}
      attachmentId={image.valore as any}
      dimension={dimension ?? GetFrontRichiesteIdImmaginiIdDimensioni.ANTEPRIMA}
      borderRadius={borderRadius}
      objectFit={objectFit}
      width={width}
      height={height}
    />
  ));

  return <Space wrap>{previewImages}</Space>;
}
